import HttpError from './ExtendedError';
import { StatusMessageType } from '../components/teamManagement/types/StatusMessageType';

const errorCodeToMessageTemplate: Map<string, string> = new Map([
  ['teamMember.error.email.denied', 'teammanagement.statusMessage.error.message.teamMember.emailDenied'],
  ['teamMember.error.duplicate', 'teammanagement.statusMessage.error.message.teamMember.existsAlready'],
  ['teamMember.error.notFound', 'teammanagement.statusMessage.error.message.teamMember.notFound'],
  ['lifecycle.command.invalid', 'teammanagement.statusMessage.error.message.invalid.command'],
  ['request.error.badPayload', 'teammanagement.statusMessage.error.message.teamMember.invalidPayload'],
  ['team.error.complete.review.lifecycle.command.passwordResetEmail.failed', 'teammanagement.statusMessage.error.message.passwordResetEmail.failed'],
]);

const getError = (errorCode: string, details?: string) => {
  return {
    titleCode: errorCode,
    messageType: 'error',
    details,
  } as StatusMessageType;
};

export const getErrorMessage = (e: Error): StatusMessageType => {
  if (e instanceof HttpError && e.body?.errorCode && errorCodeToMessageTemplate.has(e.body?.errorCode)) {
    return getError(<string>errorCodeToMessageTemplate.get(e.body.errorCode), e.body.details);
  } else {
    return getError('teammanagement.statusMessage.error.message.default');
  }
};

export const getWarningMessage = (titleCode: string): StatusMessageType => ({
  titleCode: titleCode,
  messageType: 'info',
});

export const getSuccessMessage = (titleCode: string): StatusMessageType => ({
  titleCode: titleCode,
  messageType: 'confirm',
});
